import React from "react";
import UnderConstruction from "../components/UnderConstruction";

const FBOServices = () => (
  <UnderConstruction
    eyebrow="FBO Services"
    seoTitle="FBO Services | Steck Aviation Management"
    seoDescription="FBO services from Steck Aviation Management. Coming soon."
  />
);

export default FBOServices;
